import axios from "../axios";
import h from "../helpers";
import { clientIp } from "../api-address";

const state = {
  index: async (params) => {
    const { data } = await axios.get(h.baseUrl("states"), {
      params: { ...params },
    });
    return data;
  },
  show: async (id) => {
    const { data } = await axios.get(h.baseUrl("states/" + id));
    return data;
  },
  store: async (
    name,
    code,
    variant_id,
    supplier_id,
    price,
    weight,
    colors,
    sizes,
    imageUrl
  ) => {
    const { data } = await axios.post(h.baseUrl("states"), {
      name,
      code,
      variant_id,
      supplier_id,
      price,
      weight,
      colors,
      sizes,
      imageUrl,
      ip_address: await clientIp(),
    });
    return data;
  },
  update: async (
    id,
    name,
    code,
    variant_id,
    supplier_id,
    price,
    weight,
    imageUrl
  ) => {
    const { data } = await axios.put(h.baseUrl("states/" + id), {
      name,
      code,
      variant_id,
      supplier_id,
      price,
      weight,
      imageUrl,
      ip_address: await clientIp(),
    });
    return data;
  },
  delete: async (id) => {
    const ip = await clientIp();
    const { data } = await axios.delete(
      h.baseUrl("states/" + id + `?ip_address=${ip}`)
    );
    return data;
  },
};

export default state;
